/* Shim for the forked design editor: no upgrade tiers in Brightivity; a paid action opens Get credits. */
import { useWallet } from '../app/wallet.jsx';

export function useUpgradePrompt() {
  const { openCredits } = useWallet();
  return { showUpgradePrompt: () => openCredits() };
}
export default null;
